import { Modal } from "react-bootstrap";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { qreq } from "../../shared/qrequest";

class AssetLibraryDirectoryModal extends BaseCom {
    constructor(props) {
        super(props);

        this.state = {
            info: {}
        };
    }

    submit = async (e) => {
        e.preventDefault();
        try {
            let info = {...this.state.info};
            info.parentID = this.props.parentID;
            let j = await qreq.postAsync('/api/asset-library/directory/save', info);
            if(j.errorCode === 0) {
                this.setState({ info: {} });
                this.props.onUpdate();
                this.props.onHide();
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={() => this.props.onHide()}>
                <Modal.Header closeButton>
                    Create Directory
                </Modal.Header>
                <form onSubmit={this.submit}>
                    <Modal.Body>
                        <FormInput model={this.state.info} name="name" label="Directory Name" required />
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-success" onClick={() => this.props.onHide()}><Icon icon="faSave" /> Create</button>
                        <button className="btn btn-secondary" onClick={() => this.props.onHide()}>Cancel</button>
                    </Modal.Footer>
                </form>
            </Modal>
        );
    }
}

export default withParamsAndNavigate(AssetLibraryDirectoryModal);